import styled from 'styled-components';

const TicketPageContainer = styled.div`
  display: flex;
  overflow: auto;
  height: 100%;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export default TicketPageContainer;
